var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 338 l0 -81 26 24 26 24 24 -30 c29 -36 39 -81 29 -132 -6 -33 -5 -36 10 -23 9 7 26 32 37 54 26 50 21 124 -12 168 l-22 30 23 24 22 24 -81 0 -82 0 0 -82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 353 c-60 -69 -62 -158 -6 -235 10 -14 9 -21 -6 -37 l-19 -21 76 0 77 0 0 77 0 76 -21 -19 c-25 -22 -44 -13 -71 37 -15 26 -18 47 -14 87 2 28 3 52 2 52 -2 0 -10 -8 -18 -17z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtaIcon);
export default __webpack_public_path__ + "static/media/OTA_icon.72bf3346ae8b2d03516c00db721d5b03.svg";
export { ForwardRef as ReactComponent };